const verification_record = {
    not_found: 'Запись подтверждения не найдена.',
    permission_denied: 'Доступ запрещён, пожалуйста, повторно пройдите аутентификацию.',
    not_supported_for_google_one_tap: 'Этот API не поддерживает Google One Tap.',
};
export default Object.freeze(verification_record);
